import React from 'react';

const PatientDetails = ({ patient, onClose, onViewHistory }) => {
  return (
    <div className="p-6">
      <div className="flex justify-between items-start">
        <h3 className="text-lg font-bold text-gray-900">
          Patient Details - {patient.patientId}
        </h3>
        <button 
          onClick={onClose}
          className="text-gray-400 hover:text-gray-500"
        >
          <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      </div>
      
      <div className="mt-4 space-y-4">
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <div>
            <h4 className="text-sm font-medium text-gray-500">Full Name</h4>
            <p className="mt-1 text-sm text-gray-900">{patient.name}</p>
          </div>
          <div>
            <h4 className="text-sm font-medium text-gray-500">Date of Birth</h4>
            <p className="mt-1 text-sm text-gray-900">{new Date(patient.dob).toLocaleDateString()}</p>
          </div>
          <div>
            <h4 className="text-sm font-medium text-gray-500">Gender</h4>
            <p className="mt-1 text-sm text-gray-900">{patient.gender}</p>
          </div>
          <div>
            <h4 className="text-sm font-medium text-gray-500">Blood Group</h4>
            <p className="mt-1 text-sm text-gray-900">{patient.bloodGroup}</p>
          </div>
          <div>
            <h4 className="text-sm font-medium text-gray-500">Email</h4>
            <p className="mt-1 text-sm text-gray-900">{patient.email}</p>
          </div>
          <div>
            <h4 className="text-sm font-medium text-gray-500">Phone</h4>
            <p className="mt-1 text-sm text-gray-900">{patient.phone}</p>
          </div>
        </div>
        
        <div className="pt-4 border-t border-gray-200">
          <h4 className="text-sm font-medium text-gray-500">Address</h4>
          <p className="mt-1 text-sm text-gray-900">{patient.address}</p>
        </div>

        <div className="pt-4 border-t border-gray-200">
          <h4 className="text-sm font-medium text-gray-500">Registration Info</h4>
          <div className="mt-2">
            <p className="text-sm text-gray-500">Date Joined</p>
            <p className="text-sm text-gray-900">{new Date(patient.dateJoined).toLocaleDateString()}</p>
          </div>
        </div>
      </div>
      
      <div className="mt-6 flex justify-end">
        <button
          onClick={() => {
            onClose();
            onViewHistory(patient);
          }}
          className="mr-3 px-4 py-2 border border-gray-300 rounded-md text-sm font-medium text-gray-700 hover:bg-gray-50"
        >
          View Medical History
        </button>
        <button
          onClick={onClose}
          className="px-4 py-2 bg-primary-600 text-white rounded-md hover:bg-primary-700"
        >
          Close
        </button>
      </div>
    </div>
  );
};

export default PatientDetails;
